import { createReducer, on, Action } from '@ngrx/store';

import * as GoogleSheetSyncActions from './google-sheet-sync.actions';

export const GOOGLE_SHEET_SYNC_FEATURE_KEY = 'googleSheetSync';

export interface GoogleSheetSyncState {
  isSyncing: boolean; // is Google Sheet dataset syncing
  error?: string | null; // last known error (if any)
}

export interface GoogleSheetSyncPartialState {
  readonly [GOOGLE_SHEET_SYNC_FEATURE_KEY]: GoogleSheetSyncState;
}

export const initialGoogleSheetSyncState: GoogleSheetSyncState = {
  // set initial required properties
  isSyncing: false,
};

const reducer = createReducer(
  initialGoogleSheetSyncState,
  on(GoogleSheetSyncActions.datasetEditorSyncGoogleSheet, (state) => ({ ...state, isSyncing: true, error: null })),
  on(GoogleSheetSyncActions.syncGoogleSheetSuccess, (state) => ({ ...state, isSyncing: false })),
  on(GoogleSheetSyncActions.syncGoogleSheetFailure, (state, { error }) => ({ ...state, error, isSyncing: false }))
);

export function googleSheetSyncReducer(state: GoogleSheetSyncState | undefined, action: Action) {
  return reducer(state, action);
}
